let _flexiblePromotions = [];
const observableFlexiblePromotions = new Rx.BehaviorSubject(_flexiblePromotions);

const FlexiblePromotionsRepository = {

    add(data) {

        data.forEach((item) => {

            if (item.attributes.promotion_type === 'public') {

                const indexOfProduct = this.getIndex(item.id);

                if (indexOfProduct === -1) {

                    const acronym = item.attributes.product_acronym;
                    const { runtime } = item.attributes;
                    const { devices } = item.attributes;
                    const priceId = `${acronym}_${runtime}_${devices}`;
                    item.price_id = priceId;
                    _flexiblePromotions.push(item);

                }

            } else if (item.attributes.promotion_type === 'subscription_trial') {

                const indexOfProduct = this.getIndex(item.id);

                if (indexOfProduct === -1) {

                    const priceId = 'prime_anual_trial';
                    item.price_id = priceId;
                    _flexiblePromotions.push(item);

                }

            }

        });

        observableFlexiblePromotions.onNext(_flexiblePromotions);

    },

    getPromotionById(promotionId) {

        return _flexiblePromotions.find(promotion => promotion.price_id === promotionId);

    },

    getAll() {

        return _flexiblePromotions;

    },

    replace(data) {

        _flexiblePromotions = data;
        observableFlexiblePromotions.onNext(_flexiblePromotions);

    },

    concatPromotions(data) {

        if (data[0]) {

            const indexOfPromotion =
            _flexiblePromotions.findIndex(promotion => promotion.id === data[0].id);

            if (indexOfPromotion === -1) {

                _flexiblePromotions = _flexiblePromotions.concat(data);

            }

        }

        observableFlexiblePromotions.onNext(_flexiblePromotions);

    },

    getIndex(dataId) {

        return _flexiblePromotions
            .findIndex(_flexiblePromotion => String(_flexiblePromotion.id) === String(dataId));

    },

    getObservable() {

        return observableFlexiblePromotions;

    },

};

export default FlexiblePromotionsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.flexiblePromotionsRepository.js